import React from 'react';
import { Stack, FormControl, Box, FormControlLabel, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { orderPayload, selectedVSService } from 'pages/provisioning/virtual-service/store';
import ProvisioningStyles, { CustomRadioGroup, CustomRadio } from 'pages/provisioning/virtual-service/style';

const CorsPolicy = () => {
    const [order, setOrder] = useRecoilState(orderPayload);
    const [selectedVS] = useRecoilState(selectedVSService);

    const setCorsPolicy = (corsPolicy) => {
        setOrder((prevOrder) => ({
            ...prevOrder,
            aksVirtualService: prevOrder?.aksVirtualService.map((item, index) => {
                if (index === selectedVS) {
                    return {
                        ...item,
                        aksCors: {
                            allowedHeaders: [{ allowedHeader: null, isInvalid: false }],
                            allowedOrigins: [{ allowedOrigin: null, isInvalid: false }],
                            exposeHeaders: [{ exposeHeader: null, isInvalid: false }],
                            allowedMethods: [],
                        },
                        corsPolicy,
                    };
                }
                return item;
            }),
        }));
    };
    const handleOnSelectChange = (selected) => {
        setCorsPolicy(selected);
    };

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <FormControl sx={{ justifyContent: 'center', width: '100%' }}>
                <Box id="corsPolicy">
                    <Typography className="text-label">DO YOU NEED CORS POLICY ?</Typography>
                </Box>
                <CustomRadioGroup
                    data-testid="cors-policy-group"
                    aria-label="corsPolicy"
                    name="corsPolicy"
                    row
                    value={order?.aksVirtualService?.[selectedVS]?.corsPolicy}
                    onChange={(event, value) => handleOnSelectChange(value)}
                >
                    <FormControlLabel value="Yes" control={<CustomRadio />} label="Yes" />
                    <FormControlLabel
                        value="No"
                        sx={{
                            marginLeft: '0px',
                        }}
                        control={<CustomRadio />}
                        label="No"
                    />
                </CustomRadioGroup>
            </FormControl>
        </Stack>
    );
};

export default React.memo(CorsPolicy);
